import styled from 'styled-components';
import { BottomSns } from '../../common/BottomSnsImg';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery, openKakaoLink } from '../../../utils';

export const RewardInfo = () => {
  return (
    <>
      <Wrap>
        <LabelRed>
          <LabelText>온라인 새틀라이트</LabelText>
        </LabelRed>
        <CongressContainer>
          <TopDateText>
            2025년 11월 3일
            <span>(월)</span>~12월 4일
            <span>(목)</span>
          </TopDateText>
          <Divider />
          <CongressLocation>
            <AppContainer>
              <img src={ImageUtils.ShowDownApp} alt="" />
              피망 쇼다운 홀덤 앱
            </AppContainer>
          </CongressLocation>
        </CongressContainer>
        <LabelBlue>
          <LabelText>오프라인 이벤트</LabelText>
        </LabelBlue>
        <CongressOfflineContainer>
          <DayContainer>
            <BottomDateText>2025년 12월 7일(일)</BottomDateText>
          </DayContainer>

          <FullText>
            NLH Main Event Day 1 (SHOWDOWN HOLDEM Online Qualifiers) JOPT 2026 #01
          </FullText>
          <LocationContainer>
            <CircleLocation>JP 스타디움</CircleLocation>
            <LocationText>서울 광진구 능동로 19길 35 (화양동) 광진코지웰 B1</LocationText>
          </LocationContainer>
        </CongressOfflineContainer>

        <PartnerWrap>
          <PartnerContainer>
            <PartnerTitle>주최 / 주관</PartnerTitle>
            <PartnerContent>
              <img src={ImageUtils.PartnerIcon} alt="" />
            </PartnerContent>
          </PartnerContainer>

          <RequestKakaoContainer>
            <RequestText>
              자세한 내용은 <Br />
              <span onClick={openKakaoLink}>JOPT 카카오톡 채널</span>에 <Br />
              문의해주세요!
            </RequestText>

            <img src={ImageUtils.KakaoIcon} alt="" />
          </RequestKakaoContainer>
        </PartnerWrap>
      </Wrap>
      <BottomSns />
    </>
  );
};

const Br = styled.br`
  display: block;
  ${mobileQuery} {
    display: none;
  }

  @media screen and (max-width: 500px) {
    display: block;
  }
`;

const RequestKakaoContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-left: 30px;

  border-top: 2px solid rgba(0, 0, 0, 0.5);

  border-bottom: 2px solid rgba(0, 0, 0, 0.5);

  background: #222;

  height: 170px;
  flex: 1;

  ${mobileQuery} {
    border-top: 1px solid rgba(0, 0, 0, 0.5);
    border-bottom: 1px solid rgba(0, 0, 0, 0.5);
    padding-left: 15px;
    padding-right: 15px;
    height: 94px;
    img {
      width: 40px;
    }
  }
`;
const RequestText = styled.p`
  text-align: left;
  // margin-right: 30px;

  color: rgba(255, 255, 255, 0.8);
  font-family: 'Noto Sans';
  font-size: 24px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px; /* 125% */

  span {
    color: #fae100;
    font-size: 24px;
    font-weight: 400;
    line-height: 30px;
    text-decoration-line: underline;
    text-decoration-style: solid;
    text-decoration-skip-ink: auto;
    text-decoration-thickness: 6%;
    text-underline-offset: 20%;
    cursor: pointer;
  }

  ${mobileQuery} {
    font-size: 12px;
    line-height: 15px;

    span {
      font-size: 12px;
      line-height: 15px;
    }
  }
`;

const DayContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 10px;

  ${mobileQuery} {
    margin-bottom: 5px;
    img {
      width: 12px;
    }
  }
`;

const FullText = styled.h3`
  color: #3fb5ff;
  font-size: 26px;
  line-height: 32px;
  font-weight: 600;
  letter-spacing: -1.04px;
  margin-bottom: 10px;
  text-align: left;

  span {
    font-size: 20px;
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 18px;
    margin-bottom: 10px;
    margin-top: 6px;

    span {
      font-size: 10px;
    }
  }
`;

const LocationContainer = styled.div`
  display: flex;

  ${mobileQuery} {
    align-items: center;
  }
`;

const CircleLocation = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.88px;
  border-radius: 30px;
  border: 1px solid rgba(255, 255, 255, 0.4);
  background: rgba(0, 0, 0, 0);
  padding-left: 20px;
  padding-right: 20px;
  text-align: center;
  margin-right: 10px;
  flex-shrink: 0;

  ${mobileQuery} {
    font-size: 11px;
    line-height: 23px;
    padding-left: 10px;
    padding-right: 10px;
    margin-right: 5px;
    height: 24px;
  }
`;

const LocationText = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 24px;
  font-weight: 400;
  line-height: 30px; /* 125% */
  letter-spacing: -0.96px;
  text-align: left;

  ${mobileQuery} {
    font-size: 14px;
    line-height: 18px;
  }
`;

const Wrap = styled.div`
  padding-right: 90px;
  padding-left: 90px;
  padding-bottom: 170px;
  text-align: center;

  ${mobileQuery} {
    padding-top: 13px;
    padding-right: 10px;
    padding-left: 10px;
  }
`;

const Label = styled.div`
  height: 50px;
  width: 100%;

  ${mobileQuery} {
    height: 25px;
  }
`;

const LabelRed = styled(Label)`
  border-top: 2px solid #d92a76;
  border-bottom: 1px solid #d92a76;
  background: linear-gradient(90deg, rgba(201, 0, 80, 0.7) 25.71%, rgba(164, 0, 71, 0.7) 86.89%);
  height: 42px;

  margin-top: 53px;

  ${mobileQuery} {
    margin-top: 0;
    height: 24px;

    border-top: 1px solid #d92a76;
    border-bottom: 1px solid #d92a76;
  }
`;

const LabelBlue = styled(Label)`
  border-top: 2px solid #1e95f6;
  border-bottom: 1px solid #1e95f6;
  background: linear-gradient(91deg, rgba(0, 155, 251, 0.8) 10.71%, rgba(0, 114, 207, 0.8) 84.3%);

  height: 42px;
  ${mobileQuery} {
    height: 21px;
    border-top: 1px solid #1e95f6;
  }
`;

const LabelText = styled.p`
  font-weight: 600;
  font-size: 24px;
  line-height: 38px;
  color: rgba(255, 255, 255, 0.9);
  font-weight: 600;

  ${mobileQuery} {
    font-size: 15px;
    line-height: 20px;
  }
`;

const CongressContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  background-color: #222;
  height: 136px;
  padding-left: 20px;
  padding-right: 20px;

  ${mobileQuery} {
    padding-left: 10px;
    padding-right: 10px;
    margin-bottom: 10px;
    height: 86px;
  }
`;

const CongressOfflineContainer = styled(CongressContainer)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin-bottom: 13px;
  background-color: #222;
  height: 214px;
  padding-left: 20px;
  padding-right: 20px;

  ${mobileQuery} {
    height: auto;
    padding-top: 10px;
    padding-bottom: 10px;
    margin-bottom: 5px;
    padding-left: 10px;
    padding-right: 10px;
  }
`;

const TopDateText = styled.h4`
  color: rgba(255, 255, 255, 0.8);
  font-size: 26px;
  font-weight: 400;
  letter-spacing: -0.52px;
  width: 65%;
  text-align: left;

  span {
  }

  ${mobileQuery} {
    width: 70%;
    font-size: 16px;
    line-height: 16px;
    letter-spacing: -0.56px;

    span {
      font-size: 12px;
      line-height: 16px;
    }
  }
`;

const BottomDateText = styled(TopDateText)`
  width: auto;
`;

const Divider = styled.div`
  height: 70%; // 높이 조절 (필요에 따라 조정)
  width: 1px;
  background: rgba(217, 217, 217, 0.2);
`;

const CongressLocation = styled.h4`
  width: 50%;
  color: rgba(255, 255, 255, 0.6);
  text-align: right;
  font-size: 22px;
  font-weight: 500;
  letter-spacing: -0.88px;

  ${mobileQuery} {
    font-size: 11px;
    line-height: 16px;
  }

  @media screen and (max-width: 500px) {
    width: auto;
  }
`;

const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  img {
    margin-bottom: 8px;
  }

  ${mobileQuery} {
    img {
      width: 29px;
    }
  }
`;

const PartnerWrap = styled.div`
  display: flex;
`;

const PartnerContainer = styled.div`
  width: 293px;
  margin-right: 6px;
  margin-bottom: 2px;
  &:last-child {
    margin-right: 0;
  }

  ${mobileQuery} {
    width: 136px;
    margin-right: 3px;
  }
`;

const PartnerTitle = styled.h3`
  height: 40px;

  border-bottom: 1px solid #000000;
  background: rgba(0, 0, 0, 0.5);

  font-family: 'Gmarket';

  color: rgba(255, 255, 255, 0.5);
  text-align: center;
  font-size: 20px;
  font-weight: 500;
  letter-spacing: -0.8px;
  line-height: 40px;

  ${mobileQuery} {
    font-size: 12px;
    line-height: 25px;
    height: 20px;
  }
`;

const PartnerContent = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  height: 130px;

  background: rgba(0, 0, 0, 0.2);

  ${mobileQuery} {
    height: 75px;
    img {
      width: 75px;
    }
  }
`;
